import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-m-2" }
const _hoisted_2 = { class: "p-d-field p-my-3" }
const _hoisted_3 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Editor = _resolveComponent("Editor")
  const _component_Dropdown = _resolveComponent("Dropdown")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Editor, {
      modelValue: _ctx.note.content,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.note.content = $event)),
      class: "p-m-2",
      editorStyle: "height: 220px"
    }, null, 8, ["modelValue"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('common.type') + ' *'), 1),
      _createVNode(_component_Dropdown, {
        class: ["kn-material-input", {
                    'p-invalid': !_ctx.note.type
                }],
        modelValue: _ctx.note.type,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.note.type = $event)),
        options: _ctx.documentExecutionNotesDialogDescriptor.dropdownOptions
      }, null, 8, ["class", "modelValue", "options"])
    ])
  ]))
}